import { IInterventionGroup } from '../../../interventions/interfaces/IIntervention';

export interface IInterventionsState {
  mode?: InterventionsMode;
  groups: IInterventionGroup[];
}

export enum InterventionsMode {
  Normal = 'Normal',
  RecallOrder = 'RecallOrder',
}
